// extracted by mini-css-extract-plugin
export var container = "ShareModal-module--container--n7nDh";
export var caption = "ShareModal-module--caption--vxKm2";
export var shareContainer = "ShareModal-module--shareContainer--2K7mJ";
export var shareLabel = "ShareModal-module--shareLabel--fj8H8";
export var shareButtonsContainer = "ShareModal-module--shareButtonsContainer--lLiYd";
export var shareButton = "ShareModal-module--shareButton--R6IYI";
export var closeButtonContainer = "ShareModal-module--closeButtonContainer--cwljE";
export var closeButton = "ShareModal-module--closeButton--pnsoH";